import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useGroupPurposeChartStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
    marginTop: '48px',
  },
});
